// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import www_util from '../util.js';
import { App_context } from '../context.js';
import { Link } from '../ui/link.tsx';
import Icon_windows from '../img/svg/pl/ic-windows.svg';
import Icon_mac from '../img/svg/pl/ic-mac.svg';
import Icon_android from '../img/svg/pl/ic-android.svg';
import Icon_ios from '../img/svg/pl/ic-ios.svg';
import Icon_extension from '../img/svg/pl/ic-extension.svg';
import Icon_firetv from '../img/svg/pl/ic-firetv.svg';
import Icon_smarttv from '../img/svg/pl/ic-smarttv.svg';
import Icon_appletv from '../img/svg/pl/ic-appletv.svg';
import { Svg } from '../shared/svg';
import { qa_perr, get_path_name, Breadcrumbs, Faq_page } from '../support_lib.js';
import * as desktop from './troubleshooting_desktop.js';
import * as mobile from './troubleshooting_mobile.js';
import * as tv from './troubleshooting_tv.js';
import * as extension from './troubleshooting_extension.js';
var root_path = '/support/troubleshooting';
var ic_size = {
  width: 24,
  height: 24
};
var tiles = [{
  title: 'Windows',
  href: `${root_path}/windows`,
  icon: /*#__PURE__*/React.createElement(Icon_windows, ic_size)
}, {
  title: 'Mac',
  href: `${root_path}/mac`,
  icon: /*#__PURE__*/React.createElement(Icon_mac, ic_size)
}, {
  title: 'Android',
  href: `${root_path}/android`,
  icon: /*#__PURE__*/React.createElement(Icon_android, ic_size)
}, {
  title: 'iOS',
  href: `${root_path}/ios`,
  icon: /*#__PURE__*/React.createElement(Icon_ios, ic_size)
}, {
  title: 'Browser Extension',
  href: `${root_path}/extension`,
  icon: /*#__PURE__*/React.createElement(Icon_extension, ic_size)
}, {
  title: 'Fire TV',
  href: `${root_path}/firetv`,
  icon: /*#__PURE__*/React.createElement(Icon_firetv, ic_size)
}, {
  title: 'Smart TV',
  href: `${root_path}/smarttv`,
  icon: /*#__PURE__*/React.createElement(Icon_smarttv, ic_size)
}, {
  title: 'Apple TV',
  href: `${root_path}/appletv`,
  icon: /*#__PURE__*/React.createElement(Icon_appletv, ic_size)
}];
var Support_tile = ({
  title,
  href,
  icon
}) => {
  return /*#__PURE__*/React.createElement(Link, {
    to: href,
    className: "support_tile"
  }, /*#__PURE__*/React.createElement(Svg, {
    icon: icon
  }), /*#__PURE__*/React.createElement("p", null, title));
};
var Platform_tiles = () => {
  return /*#__PURE__*/React.createElement("ul", {
    className: "platform_tiles"
  }, tiles.map(tile => /*#__PURE__*/React.createElement("li", {
    key: tile.title,
    className: "platform_tile"
  }, /*#__PURE__*/React.createElement(Support_tile, tile))));
};
var platforms = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, desktop), mobile), tv), {}, {
  extension
});
var get_alternative_id = str => {
  var last_ = str.lastIndexOf('_');
  if (last_ == -1) return str;
  return str.substring(0, last_);
};
var use_articles = ({
  platform,
  state,
  set_state
}) => {
  var raw = platforms[platform];
  if (!platform || !raw) return [];
  var _entries = raw.entries.reduce((a, v) => _objectSpread(_objectSpread({}, a), {}, {
    [v.id]: v
  }), {});
  var no = opt => () => {
    var id = opt.id,
      step = opt.step;
    var a_id = get_alternative_id(id);
    var entry = _entries[id] || _entries[a_id];
    qa_perr('no', platform, entry.title, opt);
    set_state(v => _objectSpread(_objectSpread({}, v), {}, {
      [id]: _objectSpread(_objectSpread({}, v[id]), {}, {
        [step]: 'no'
      })
    }));
  };
  var yes = opt => () => {
    var id = opt.id,
      step = opt.step;
    var a_id = get_alternative_id(id);
    var entry = _entries[id] || _entries[a_id];
    qa_perr('yes', platform, entry.title, opt);
    set_state(v => _objectSpread(_objectSpread({}, v), {}, {
      [id]: _objectSpread(_objectSpread({}, v[id]), {}, {
        [step]: 'yes'
      })
    }));
  };
  return [raw.entries, raw.content({
    state,
    yes,
    no
  })];
};
var Root = function Troubleshooting(props) {
  var _useContext = useContext(App_context),
    user = _useContext.user;
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    set_state = _useState2[1];
  var platform = pathname.split('/')[3];
  var _use_articles = use_articles({
      platform,
      state,
      set_state
    }),
    _use_articles2 = _slicedToArray(_use_articles, 2),
    entries = _use_articles2[0],
    content = _use_articles2[1];
  useEffect(() => {
    www_util.perr_www_visit({
      id: 'www_support_troubleshooting_visit',
      user
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "support_page troubleshooting"
  }, !platform || !entries || !content ? /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    root: "Help center"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, "Troubleshooting"), /*#__PURE__*/React.createElement("p", {
    className: "subtitle"
  }, "Which platform do you need help with?"), /*#__PURE__*/React.createElement(Platform_tiles, null), /*#__PURE__*/React.createElement("p", {
    className: "bottom"
  }, "Can\u2019t find what you need or have more questions? ", /*#__PURE__*/React.createElement(Link, {
    to: "/premium_support"
  }, "Submit a request"))) : /*#__PURE__*/React.createElement("div", {
    className: "articles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }), /*#__PURE__*/React.createElement("div", {
    className: "right"
  }, /*#__PURE__*/React.createElement(Breadcrumbs, {
    root: "Help center"
  }), /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, get_path_name(platform)))), /*#__PURE__*/React.createElement(Faq_page, {
    q: '',
    entries: entries,
    content: content,
    wrapper: "article",
    closable: true,
    no_observe: true
  })));
};
export { Root };